const ShiftStatus = {
    Started: "started",
    Ended: "ended",
    Closed: "closed",
  };
  
  export default ShiftStatus;
  